import { render, staticRenderFns } from "./OuterDashCard.vue?vue&type=template&id=4a4749e3&"
import script from "./OuterDashCard.vue?vue&type=script&lang=js&"
export * from "./OuterDashCard.vue?vue&type=script&lang=js&"
import style0 from "./OuterDashCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports